var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import selectn from "selectn";

import StoryHeader from "../StoryHeader";
import StoryContent from "../StoryContent";
import StoryFooter from "../StoryFooter";
import ErrorBoundary from "components/Library/ErrorBoundary";

import styles from "./StoryCard.css";
import { FACTS_MATTER_TEMPLATE } from "../../../config/constants";

var StoryCard = function (_Component) {
  _inherits(StoryCard, _Component);

  function StoryCard() {
    _classCallCheck(this, StoryCard);

    return _possibleConstructorReturn(this, (StoryCard.__proto__ || Object.getPrototypeOf(StoryCard)).apply(this, arguments));
  }

  _createClass(StoryCard, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          story = _props.story,
          hideHeader = _props.hideHeader,
          hideFooter = _props.hideFooter,
          header = _props.header,
          storyType = _props.storyType,
          permalinkId = _props.permalinkId,
          index = _props.index;

      if (!story) return null;

      return React.createElement(
        ErrorBoundary,
        null,
        React.createElement(
          "div",
          {
            id: story.id,
            className: classNames("story-card", styles.root, this.props.className, story.slideIn ? styles.slideIn : {}, story.template === FACTS_MATTER_TEMPLATE && styles.factsMatter || story.is_featured && !selectn("rubric.name", story) && styles.featured) },
          React.createElement(
            "div",
            { className: classNames("permalink", styles.hide) },
            story.permalink
          ),
          !hideHeader && (header || React.createElement(StoryHeader, { story: story })),
          React.createElement(StoryContent, { story: story, storyType: storyType, permalinkId: permalinkId, index: index }),
          !hideFooter && React.createElement(StoryFooter, { story: story })
        )
      );
    }
  }]);

  return StoryCard;
}(Component);

StoryCard.propTypes = {
  story: PropTypes.object,
  storyType: PropTypes.oneOf(["newsletter"]),
  hideHeader: PropTypes.bool,
  hideFooter: PropTypes.bool,
  header: PropTypes.element,
  className: PropTypes.string,
  permalinkId: PropTypes.string
};

export default StoryCard;


// WEBPACK FOOTER //
// ./src/components/Library/StoryCard/StoryCard.js